<form [formGroup]="form" class="fieldgroup edit w-100" [ngClass]="{'pl-0':deliverableList && deliverableList.length}" (ngSubmit)="isSubmitted = true; form.valid && submit()" [attr.id]="formId">
	<div class="createNew-invoice__items">
		<fieldset class="add-items mt-2" [ngClass]="{'has-error': isSubmitted && form.controls.title.errors && form.controls.title.errors.required}">
			<select class="add-newItems" *ngIf="deliverableList && deliverableList.length;"
				#newItemTitle=select2Directive
				app-select2
				(itemSelected)="onChangeItem($event)"
				[selected]="selectedItem ? {id: selectedItem.name, text: selectedItem.name} : {}"
				i18n-data-placeholder="@@placeholder.add_items"
				data-placeholder="Add Item(s)"
				formControlName="title"
				[showAddNewItem]="'true'"
				[addNewItemTitle]="itemTitleText"
				[options]="{
					data: deliverableList,
					idColumn: 'name',
					textColumn: 'name',
					tags: false,
					dropdownParent: 'span.item-title-'+(index ? index : formId)
				}">
				<option></option>
			</select>
			<span class="field-error" i18n="@@error.required.delivery_type">Please Type Delivery Item</span>
		</fieldset>
	</div>
</form>
